import { createAction, createReducer, on, props } from '@ngrx/store';
import { UpsellBooking } from '../models/upsell-booking.interface';

// Action Types
export const upsellBookingStatus = createAction('upsellBookingStatus', props<{ data }>());
export const updateAbcTimeslotStatus = createAction('updateAbcTimeslotStatus', props<{ abcTimeslotsAvailable: boolean }>());
export const updateCcdTimeslotStatus = createAction('updateCcdTimeslotStatus', props<{ ccdTimeslotsAvailable: boolean }>());
export const refreshUpsellBooking = createAction('refreshUpsellBooking', props<{ state: UpsellBooking }>());
export const resetUpsellBooking = createAction('resetUpsellBooking');

// Initial State
const initialState: UpsellBooking = {
  showUpsellScreen: false,
  upsellConverted: false,
  abcTimeslotsAvailable: true,
  ccdTimeslotsAvailable: true,
  currentBooking: '',
  upsellBooking: ''
};

// Reducer
export const upsellBookingReducer = createReducer(
  initialState,
  on(upsellBookingStatus, (state, { data }) => ({
    ...state,
    showUpsellScreen: data.showUpsellScreen,
    currentBooking: data.currentBooking,
    upsellBooking: data.upsellBooking,
    upsellConverted: data.upsellConverted
  })),
  on(updateAbcTimeslotStatus, (state, { abcTimeslotsAvailable }) => ({
    ...state,
    abcTimeslotsAvailable
  })),
  on(updateCcdTimeslotStatus, (state, { ccdTimeslotsAvailable }) => ({
    ...state,
    ccdTimeslotsAvailable
  })),
  on(refreshUpsellBooking, (state, { state: newState }) => ({
    ...newState
  })),
  on(resetUpsellBooking, () => ({
    ...initialState
  }))
);
